import React from 'react'
import { Layout as AntdLayout, Grid } from 'antd'
import { useSiderContext } from '../sider/context'
import { SIDER_WIDTH_COLLAPSED, SIDER_WIDTH_EXPANDED } from '../siderOffset'

export interface LayoutProps {
  children?: React.ReactNode
  Sider?: React.FC
  Header?: React.FC
  Footer?: React.FC
  OffLayoutArea?: React.FC
}

export const Layout: React.FC<LayoutProps> = ({
  children,
  Sider,
  Header,
  Footer,
  OffLayoutArea,
}) => {
  const breakpoint = Grid.useBreakpoint()
  const isMobile = typeof breakpoint.lg === 'undefined' ? false : !breakpoint.lg
  const { collapsed } = useSiderContext()

  // Calculate margin based on sider state. The widths are shared with
  // `useSiderOffset`, which fixed-position bars inside the content use to line
  // themselves up with this margin.
  const getSiderMargin = () => {
    if (!Sider || isMobile) return '0px'
    return `${collapsed ? SIDER_WIDTH_COLLAPSED : SIDER_WIDTH_EXPANDED}px`
  }

  return (
    <AntdLayout style={{ minHeight: '100vh', flexDirection: 'row' }}>
      {Sider && <Sider />}
      <AntdLayout
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          marginLeft: getSiderMargin(),
          transition: 'margin-left 0.2s ease',
        }}
      >
        {Header && <Header />}
        <AntdLayout.Content style={{ flex: 1 }}>
          <div
            style={{
              padding: '1em 2em',
              height: '100%',
            }}
          >
            {children}
          </div>
          {OffLayoutArea && <OffLayoutArea />}
        </AntdLayout.Content>
        {Footer && <Footer />}
      </AntdLayout>
    </AntdLayout>
  )
}
